import React, { Component } from "react";
import { app, store } from "../../index";
import moment from "moment";
import { tnmformatnumber } from "../../services/tnminvnumbers";
import { connect } from "react-redux";
import downloadPDF from "./tnmPDFDownload";
import { newfeedback } from "../../actions/feedback";
import Roundy from "../../services/roundy";
import {
  Header,
  Icon,
  Grid,
  Divider,
  Button,
  Image,
  Table,
} from "semantic-ui-react";
class tnmPDF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entries: null,
      totalhours: null
    };
  }

  pdfDownload(tminfo) {
    downloadPDF({
      ...tminfo,
      entries: this.state.entries
    });
  }
  componentDidMount() {
    if (this.props.tnm && !this.state.entries) {
      this.getEntries();
      this.gettnmtotals();
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.tnm && !this.state.entries) {
      this.getEntries();
    }
  }
  gettnmtotals() {
    console.log("Relavent tms")
    app
      .service("tmsheets")
      .find({
        query: {
          workordernumber: this.props.wodinfo.workOrderNbr,
          wedate: {
            $lt: this.props.tnm.wedate
          }
        }
      })
      .then(tnms => {
        console.log("Relavent tms", tnms)
        tnms = tnms.data ? tnms.data : tnms;
        if (tnms.length) {
          
          // var tmtotal = 0
          let tmtotal = tnms.reduce((a, b) => a + b.amount, 0);
          console.log("TmTotal", tmtotal);
          tmtotal = Roundy(tmtotal);
          return tmtotal;
        } else {
          return 0;
        }
      })
      .then(tmtoal =>
        this.setState({
          prevtmtotal: tmtoal
        })
      );
  }

  getEntries() {
    if (
      this.props.tnm &&
      (this.props.tnm.laborfee || this.props.tnm.materialfee) &&
      !this.state.entries
    ) {
      let entries = [];
      app
        .service("dailylaborentries")
        .find({
          query: {
            workordernumber: this.props.tnm.workordernumber,
            tmnumber: this.props.tnm.tmnumber
          }
        })
        .then(response => {
          console.log("Labor Entries", response);
          if (response.length) {
            response = response.filter(entry => entry.hours > 0);
            entries = entries.concat(response);
          }
        })
        .then(() => {
          return app.service("dailymaterialentries").find({
            query: {
              workordernumber: this.props.tnm.workordernumber,
              tmnumber: this.props.tnm.tmnumber
            }
          });
        })
        .then(response => {
          if (response.data) {
            response = response.data;
          }
          if (response.length) {
            response.map(
              mat => (mat.amount = (mat.amount * mat.markuppercent).toFixed(2))
            );
            entries = entries.concat(response);
          }
          let totalhours = 0;
          entries.map(ent => {
            if (ent.hours) {
              totalhours += ent.hours;
            }
          });

          this.setState({
            entries,
            totalhours
          });
        });
    }
  }
  fixtnm(tnm, amount) {
    app.service("tmsheets").patch(tnm.id, {
      amount: amount
    });
  }
  genTable() {
    if (this.state.entries && this.state.entries.length) {
      return this.state.entries.map(entry => {
        let employee = this.props.employees.find(
          emp => emp.empnumber === entry.empnumber
        );
        if (entry.hours && entry.hours > 0) {
          let payrate = parseFloat(entry.payrate).toFixed(2);
          // labor entry
          return (
            <Table.Row>
              <Table.Cell>
                {moment(entry.dateperformed).format("MM/DD/YY")}
              </Table.Cell>
              <Table.Cell> {entry.empname} </Table.Cell>
              <Table.Cell> {employee.discipline.replace(",", "")} </Table.Cell>
              <Table.Cell> {entry.hours} </Table.Cell>
              <Table.Cell> {payrate} </Table.Cell>
              <Table.Cell> $ {(entry.hours * payrate).toFixed(2)} </Table.Cell>
            </Table.Row>
          );
        } else if (entry.matname) {
          // material entry
          return (
            <Table.Row>
              <Table.Cell>
                {moment(entry.datepurchased).format("MM/DD/YY")}
              </Table.Cell>
              <Table.Cell> {entry.matname} </Table.Cell>
              <Table.Cell> Material </Table.Cell> <Table.Cell> - </Table.Cell>
              <Table.Cell> $ {entry.amount} </Table.Cell>
              <Table.Cell> $ {entry.amount} </Table.Cell>
            </Table.Row>
          );
        }
      });
    }
  }

  render() {
    let tnm = this.props.tnm;
    let custinfo = this.props.custinfo;
    let wodinfo = this.props.wodinfo;
    let amount = Roundy(tnm.laborfee + tnm.materialfee + tnm.travelfee);

    tnm = {
      ...tnm,
      wod: wodinfo,
      amount,
      prevtmtotal: this.state.prevtmtotal,
      customer: custinfo
    };
    console.log(tnm.amount);

    if (tnm.invoicenumber) {
      "I" +
        tnm.invoicenumber +
        "-" +
        tnm.custnumber +
        "-" +
        moment(tnm.createdate).format("YY");
    }
    tnm.tmnumber = tnmformatnumber(tnm);

    moment(tnm.createdate).format("YY");
    if (this.props.custinfo) {
      return (
        <div className="tnmPDF">
          <Grid>
            <Grid.Row>
              <Grid.Column width={6}>
                <Image
                  size="large"
                  src={require("../estimates/custPrintLetterhead.png")}
                />
              </Grid.Column>
              <Grid.Column textAlign="center" width={4}>
                <Header as="h4"> {"8390 Currency Dr."} </Header>
                <h4> {"\n Riviera Beach Fl. 33404 Unit 4"} </h4>
                <h4> Phone: 561 - 844 - 8886 </h4>
                <h4> Fax: 561 - 842 - 3929 </h4>
              </Grid.Column>
            </Grid.Row>
            <Divider />
            <Grid.Row>
              <Grid.Column width={10}>
                <h2>
                  Time and material Charges Report for {custinfo.custname}
                  Created on {moment(tnm.wedate).format("MM/DD/YY")}
                </h2>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>
                <Table basic="very" singleLine>
                  <Table.Row>
                    <Table.Cell>
                      <h5> Written For: </h5>
                    </Table.Cell>
                    <Table.Cell> {custinfo.custname} </Table.Cell>
                    <Table.Cell>
                      <h5> Purchase Order Number: </h5>
                    </Table.Cell>
                    <Table.Cell> {wodinfo.poNbr} </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <h5> Date: </h5>
                    </Table.Cell>
                    <Table.Cell>
                      {moment(tnm.wedate).format("MM/DD/YY")}
                    </Table.Cell>
                    <Table.Cell>
                      <h5> EDF#: </h5>
                    </Table.Cell>
                    <Table.Cell> {tnm.workordernumber} </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <h5> Job Description#: </h5>
                    </Table.Cell>
                    <Table.Cell> {tnm.description} </Table.Cell>
                    <Table.Cell>
                      <h5> T & M#: </h5>
                    </Table.Cell>
                    <Table.Cell> {tnm.tmnumber} </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <h5> Acc#: </h5>
                    </Table.Cell>
                    <Table.Cell> {wodinfo.acctNbr} </Table.Cell>
                    <Table.Cell>
                      <h5> TJA#: </h5>
                    </Table.Cell>
                    <Table.Cell> {wodinfo.tjaNbr} </Table.Cell>
                  </Table.Row>
                </Table>
                <Divider />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>
                <Table basic="very" singleLine>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell> Date </Table.HeaderCell>
                      <Table.HeaderCell> Name </Table.HeaderCell>
                      <Table.HeaderCell> Classification </Table.HeaderCell>
                      <Table.HeaderCell> Hours </Table.HeaderCell>
                      <Table.HeaderCell> Rate </Table.HeaderCell>
                      <Table.HeaderCell> Amount </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body> {this.genTable()} </Table.Body>
                  <Table.Footer>
                    <Table.Row>
                      <Table.HeaderCell>
                        <Button onClick={() => this.pdfDownload(tnm)}>
                          <Icon name="download" />
                        </Button>
                      </Table.HeaderCell>
                      <Table.HeaderCell>
                        <Button
                          onClick={() =>
                            app
                              .service("tmsheets")
                              .remove(tnm.id)
                              .then(() =>
                                store.dispatch(
                                  newfeedback({
                                    color: "green",
                                    icon: "cancel",
                                    header: "TNMS Deleted",
                                    body: "T & M Deletion Success"
                                  })
                                )
                              )
                          }
                          disabled={tnm.amount > 0}
                        >
                          <Icon name="cancel" />
                        </Button>
                      </Table.HeaderCell>
                      <Table.HeaderCell>
                        <h5> Total Hours: </h5>
                      </Table.HeaderCell>
                      <Table.HeaderCell>
                        {this.state.totalhours}
                      </Table.HeaderCell>
                      <Table.HeaderCell>
                        <h5> TM Total: </h5>
                      </Table.HeaderCell>
                      <Table.HeaderCell> $ {tnm.amount} </Table.HeaderCell>
                    </Table.Row>
                  </Table.Footer>
                </Table>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      );
    } else {
      return <div />;
    }
  }
}

function mapStateToProps(state) {
  return {
    employees: state.employees.employees,
    customers: state.custinfo.customers,
    wods: state.workorders.derivatives
  };
}
export default connect(mapStateToProps)(tnmPDF);



// WEBPACK FOOTER //
// ./src/components/pdf/tnmpdf.js